// Backtest client.

import { fetchJson, URLS } from "./client";
import type { BacktestDetailDto, BacktestResponseDto, SaveStrategyRequestDto } from "./types";

/** All-zero GUID the backend returns for degraded runs (no candles / no resolvable indicators). */
export const EMPTY_BACKTEST_ID = "00000000-0000-0000-0000-000000000000";

/**
 * Fetch the heavy render payload (exact candle window + per-bar indicator series the engine
 * computed) for a completed run. The chart renders this verbatim instead of recomputing.
 * 404s if the id is unknown or its short-lived detail has expired (re-run to regenerate).
 */
export function getBacktestDetail(backtestId: string, signal?: AbortSignal): Promise<BacktestDetailDto> {
  return fetchJson<BacktestDetailDto>(`${URLS.historicalIndicators}/Backtests/${backtestId}/detail`, { signal });
}

export interface BacktestRequest {
  strategy: SaveStrategyRequestDto["spec"];
  direction: "long" | "short" | "both";
  minOccurrences: number;
  fromDate?: string | null;
  toDate?: string | null;
}

export function runBacktest(req: BacktestRequest, signal?: AbortSignal): Promise<BacktestResponseDto> {
  return fetchJson<BacktestResponseDto>(`${URLS.historicalIndicators}/Backtests/run`, {
    method: "POST",
    body: req,
    signal,
  });
}
